'use client';

import { fireHermesWarmup } from '@/lib/hermes-warmup';
import { useEffect } from 'react';

/**
 * 2026-06-16 — fires a one-shot warmup ping at the orchestrator the
 * moment /studio/test-chat mounts. The orchestrator forwards it to
 * hermes /health (cheap, unauthenticated) which wakes the Cloudflare
 * Container DO from sleep.
 *
 * Why a separate client island: the test-chat page itself is a server
 * component, and we don't want to entangle this side effect with
 * TwinChatPanel (which lives behind /e/{slug} owner preview too).
 * Mounting a tiny client component as the first child of the page
 * keeps the warmup logic isolated + opt-out-friendly.
 *
 * Idempotency: a useRef guard wouldn't survive React Strict Mode
 * double-mount in dev, but a single duplicate /health ping is harmless
 * (~5ms in steady state). Skipping the guard keeps the code small.
 *
 * Fail-soft: any error is swallowed. The chat path itself doesn't care
 * whether warmup succeeded; it just makes the FIRST message faster.
 */
export function HermesPrewarmTrigger() {
  useEffect(() => {
    // AXQA-20260618-04 (2026-06-18) — fireHermesWarmup adds a 45s
    // sessionStorage dedupe so navigating across the studio sidebar
    // doesn't re-ping a container that's already warm.
    void fireHermesWarmup('/api/me/hermes-warmup');
  }, []);
  return null;
}
